// extracted by mini-css-extract-plugin
module.exports = {"input":"styles_input__nXgyz","label":"styles_label__k1H4G"};